// TransactionsPrintFooter
import React from 'react'

const TransactionsPrintFooter = () => {
  return (
    // <div className="w-full py-4 bottom-0 left-0 right-0 border-t border-gray-200"></div>
    <div className="mx-auto text-center text-ep-gray-400 text-sm">
        <p className="text-ep-gray-400">
            <span className="text-ep-primary-600 font-medium">Disclaimer: </span>This is an auto generated report.
        </p>
        <p className="text-ep-gray-400">
        For further inquiries, contact <span className="text-ep-primary-600 font-medium">business@earnipay.com</span>
        </p>
    </div>
  )
}

export default TransactionsPrintFooter